import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { apiBaseUrl } from 'src/config';
import { Observable } from 'rxjs';

@Injectable()
export class DownloadApi {
  private readonly http = inject(HttpClient);

  /**
   * Retrieves the PDF-Export for one or more Machine-Tasks which haven't been executed yet.
   */
  getMachineTaskListPDF$(ids: string[]): Observable<Blob> {
    return this.http.post(
      apiBaseUrl + '/machinetask/export/list/pdf',
      { ids: ids },
      { responseType: 'blob' }
    );
  }

  /**
   * Retrieves the PDF-Export for one or more Machine-Tasks which have been executed yet.
   */
  getMachineTaskHistoryPDF$(ids: string[]): Observable<Blob> {
    return this.http.post(
      apiBaseUrl + '/machinetask/export/history/pdf',
      { ids: ids },
      { responseType: 'blob' }
    );
  }

  /**
   * Retrieves the PDF-Export for one or more Tooling-Tasks which haven't been executed yet.
   */
  getToolingTaskListPDF$(ids: string[]): Observable<Blob> {
    return this.http.post(
      apiBaseUrl + '/toolingtask/export/list/pdf',
      { ids: ids },
      { responseType: 'blob' }
    );
  }

  /**
   * Retrieves the PDF-Export for one or more Tooling-Tasks which have been executed yet.
   */
  getToolingTaskHistoryPDF$(ids: string[]): Observable<Blob> {
    return this.http.post(
      apiBaseUrl + '/toolingtask/export/history/pdf',
      { ids: ids },
      { responseType: 'blob' }
    );
  }
}
